export const styles = {
  appsumoNote: {
    textAlign: "left",
    padding: 1.5,
    backgroundColor: "blue.lightShade1",
    marginBottom: 2,
    borderRadius: 1,
  },
};
